var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiv3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.664062,
    width: 68,
    height: 68,
    rx: 20,
    fill: "#06BA63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84992,
    clipPath: "url(#clip0_2046_58102)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44.3839 13H25.0371C17.9867 13 13.9922 16.9946 13.9922 24.0448V43.3733C13.9922 50.4237 17.9867 54.4183 25.0371 54.4183H44.3839C51.4343 54.4183 55.4104 50.4237 55.4104 43.3733V24.0448C55.4104 16.9946 51.4343 13 44.3839 13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1104 28.2578C24.1716 28.2578 23.3984 29.0309 23.3984 29.9881V44.2176C23.3984 45.1565 24.1716 45.9296 25.1104 45.9296C26.0676 45.9296 26.8408 45.1565 26.8408 44.2176V29.9881C26.8408 29.0309 26.0676 28.2578 25.1104 28.2578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7744 21.4688C33.8356 21.4688 33.0625 22.2419 33.0625 23.1991V44.2211C33.0625 45.16 33.8356 45.9332 34.7744 45.9332C35.7316 45.9332 36.5047 45.16 36.5047 44.2211V23.1991C36.5047 22.2419 35.7316 21.4688 34.7744 21.4688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3085 35.7734C43.3513 35.7734 42.5781 36.5466 42.5781 37.5038V44.2228C42.5781 45.1616 43.3513 45.9347 44.2901 45.9347C45.2473 45.9347 46.0205 45.1616 46.0205 44.2228V37.5038C46.0205 36.5466 45.2473 35.7734 44.3085 35.7734Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2046_58102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(13.6641 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv3);
export default __webpack_public_path__ + "static/media/div3.577754afbebca15af57bf230d1ec7d2f.svg";
export { ForwardRef as ReactComponent };